import {ClientProps} from "@/interfaces/client_types.ts";
import {useForm} from "react-hook-form";
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {ImportFormProps} from "@/components/Clients/Form/Interface/ImportFormProps.ts";
import {DefaultProps} from "@/components/Clients/Form/Interface/DefaultProps.ts";
import {ClientSchema} from "@/components/Clients/Form/Interface/DefaultSchema.ts";
import {Alert} from "@/components/_Shared/Form/Buttons/Alert.tsx";
import {Error_Component, MethodHandler} from "@/components/misc.tsx";
import {ClientFormBase} from "@/components/Clients/Form/ClientFormBase.tsx";
import { createClient, updateClient } from "@/api/client";

export function ClientForm({formProps, method} : {formProps?: ClientProps, method: "POST" | "PUT"}) {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitSuccessful, isSubmitting },
        control,
        setError,
    } = useForm<z.infer<typeof ClientSchema>>({
        resolver: zodResolver(ClientSchema),
        defaultValues: formProps ? ImportFormProps({formProps}) : DefaultProps()
    })

    const onSubmit = async (data: z.infer<typeof ClientSchema>) => {
        const method_handler = MethodHandler(method, createClient, updateClient)

        if (method_handler) {
            const response = await method_handler(data)

            if (response.operation === "ERROR") {
                setError("root", {message: "An error occurred while submitting the client form."})
            }
        } else {
            console.error("Method handler not found")
        }
    }

    return (
        <>
            {isSubmitSuccessful &&
                <Alert
                    title="Success"
                    description="Client successfully created"
                    redirects={
                        [
                            {label: "To Client Table", value: "/clients/list"},
                            {label: "To Dashboard", value: "/main_menu"}
                        ]
                    }
                />}

            {errors.root && <Error_Component errorString={errors.root.message || "An error occurred"} />}

            <ClientFormBase
                method={method}
                register={register}
                errors={errors}
                control={control}
                onSubmit={handleSubmit(onSubmit)}
                isProcessing={isSubmitting}
            />

        </>
    )
}